/**
 * Re-shapes locale data for expected shape in intl-runtime
 */
export function transformLocaleData(originalLocaleData) {
    var lang = originalLocaleData.lang, locale = originalLocaleData.locale, langMode = originalLocaleData.langMode, baseCurrency = originalLocaleData.baseCurrency, _a = originalLocaleData.momentLocale, _b = _a === void 0 ? {} : _a, _c = _b.key, momentLocaleKey = _c === void 0 ? '' : _c, _d = _b.data, momentLocaleData = _d === void 0 ? {
        longDateFormat: {},
    } : _d, _e = originalLocaleData.numeralLocale, _f = _e === void 0 ? {} : _e, _g = _f.key, numeralLocaleKey = _g === void 0 ? '' : _g, _h = _f.data, numeralLocaleData = _h === void 0 ? {
        // default delimiters
        delimiters: {
            thousands: ',',
            decimal: '.',
        },
        // default currency symbol
        currency: {
            symbol: '$',
        }
    } : _h, timeZone = originalLocaleData.timeZone, _j = originalLocaleData.calendar, calendar = _j === void 0 ? {
        firstWeekDay: 1,
        startDayHour: 8,
        endDayHour: 17,
        defaultCalView: 2,
    } : _j, prefDistanceUnit = originalLocaleData.prefDistanceUnit;
    // Parse keys for data
    var splitNumeralLocaleKey = numeralLocaleKey.split('_');
    var symbolLocation = splitNumeralLocaleKey[2] === 'true' ? 'after' : 'before';
    var numberSign = splitNumeralLocaleKey[3] === '0' ? 'standard' : 'accounting';
    var currencySign = splitNumeralLocaleKey[4] === '0' ? 'standard' : 'accounting';
    var splitMomentLocaleKey = momentLocaleKey.split('_');
    var timeSeparator;
    switch (splitMomentLocaleKey[2]) {
        case '0':
            timeSeparator = ':';
            break;
        case '1':
            timeSeparator = '.';
            break;
        case '2':
            timeSeparator = ',';
            break;
        default:
            timeSeparator = ':';
    }
    var hour12 = splitMomentLocaleKey[3] === 'true';
    return {
        lang: lang,
        locale: locale,
        localeMode: langMode,
        dateFormat: momentLocaleData.longDateFormat,
        numberFormat: {
            numberSign: numberSign,
            delimiters: numeralLocaleData.delimiters,
        },
        currencyFormat: {
            symbolLocation: symbolLocation,
            currencySign: currencySign,
            baseCurrency: baseCurrency,
            currencySymbol: numeralLocaleData.currency.symbol,
        },
        timeFormat: {
            timeSeparator: timeSeparator,
            hour12: hour12,
            timeZone: timeZone,
        },
        calendarFormat: calendar,
        distanceUnit: prefDistanceUnit,
        messages: {},
    };
}
